module.exports = {"230227100":"富裕镇","230227101":"富路镇","230227102":"富海镇","230227103":"二道湾镇","230227104":"龙安桥镇","230227105":"塔哈镇","230227200":"繁荣乡","230227201":"绍文乡","230227202":"忠厚乡","230227203":"友谊达斡尔族满族柯尔克孜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230227.json
// module id = 790
// module chunks = 0